import React, { useEffect, useState } from 'react';
import NavBar from '../components/NavBar';
import { Container, Row, Col, Card } from 'react-bootstrap';
import axios from 'axios';

import Constants from '../Constants';
import { useNavigate } from 'react-router-dom';
import { AuthProvider, useAuth } from '../AuthContext';

function UserProfileView() {
    const [user, setUser] = useState(null);
    const [plan, setPlan] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [cancelling, setCancelling] = useState(false);
    const navigate = useNavigate();

    const { token } = useAuth();

    useEffect(() => {
        if(!token) {
            navigate('/login');
        }

        async function loadProfile() {
            try {
                const user_id = localStorage.getItem(Constants.USER_ID);
                if(!user_id) {
                    setError('No user logged in.');
                    navigate('/login');
                    return;
                }

                const headers = { authorization: token };
                const profileResponse = await axios.get(Constants.SERVER_URL + '/user_profile/' + user_id,
                                                        {headers, withCredentials: true });
                setUser(profileResponse.data.user);
                setPlan(profileResponse.data.plan);
            } catch (error) {
                console.error('Failed to load profile:', error.message);
                setError('Unable to load profile.');
            } finally {
                setLoading(false);
            }
        }
        loadProfile();
    }, [token]);

    async function handleCancelPlan() {
        setCancelling(true);
        try {
            const user_id = localStorage.getItem(Constants.USER_ID);
            const url = Constants.SERVER_URL + '/cancel_subscription/' + user_id;
            const headers = { authorization: token };
            await axios.delete(url, {headers, withCredentials: true });
            setPlan({ ...plan, status: 'cancelled' });

            localStorage.removeItem("aeoaudited-token");
            localStorage.removeItem(Constants.USER_EMAIL);
            localStorage.removeItem(Constants.USER_ID);
            localStorage.removeItem(Constants.SIGNUP_SELECTED_PLAN);
            localStorage.removeItem(Constants.SIGNUP_USER_EMAIL);
            // navigate('/login');
            navigate('/signup');

        } catch (error) {
            console.error('Failed to cancel plan:', error.message);            
        } finally {
            setCancelling(false);
        }
    }

    if(loading) {
        return <div>Loading your profile...</div>;
    }

    if(error) {
        return <div style={styles.error}>{error}</div>;
    }

    return (
        <React.Fragment>
            <NavBar />
            <div style={styles.container}>
                <div className='section'>
                    <h3>Account Details</h3>
                    <p><strong>Email:</strong> {user.email}</p>
                </div>

                {plan ? (
                    <Row >
                        <Col>
                            <Card className='section'>
                                <h3>Plan</h3>
                                <p><strong>Plan:</strong> {plan.name}</p>
                                <p><strong>Billing Interval:</strong> {plan.billing_interval}</p>
                                <p><strong>Status:</strong> {plan.status}</p>
                                <p><strong>Renews:</strong> {new Date(plan.renewal_date).toLocaleDateString()}</p>
                                {plan.status !== 'cancelled' && (
                                    <button  onClick={handleCancelPlan}
                                            disabled={cancelling}>
                                        {cancelling ? 'Canceling...' : 'Cancel Plan'}
                                    </button>
                                )}
                            </Card>
                        </Col>
                    </Row>
                ) : (
                    <p>No active plan found.</p>
                )}
            </div>
        </React.Fragment>
    );
}

const styles = {
    container: {
        padding: '24px',
        maxWidth: '600px',
        margin: '0 auto',
        marginTop: '80px',
        fontFamily: 'sans-serif'
    },
    error: {
        color: 'red',
        textAlign: 'center',
        marginTop: '20px'
    }
};

export default UserProfileView;
